import app from 'apprun';

declare const L;
declare const jQuery;
const $ = jQuery;

let map_data;
let osm_markers_cluster;
let markers = [];
let houzezMap;
// let prev_zoom_level;
let current_marker = 0;

let circle;

// Global boundary variables
let southwest;
let northeast;

function getDistance(origin, destination) {
  // return distance in meters
  const lon1 = toRadian(origin[1]),
    lat1 = toRadian(origin[0]),
    lon2 = toRadian(destination[1]),
    lat2 = toRadian(destination[0]);

  const deltaLat = lat2 - lat1;
  const deltaLon = lon2 - lon1;

  const a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
  const c = 2 * Math.asin(Math.sqrt(a));
  const EARTH_RADIUS = 6371;
  return c * EARTH_RADIUS * 1000;
}
function toRadian(degree) {
  return degree * Math.PI / 180;
}

app.on('map', (mapData, filtered) => houzezAddMarkers(mapData, filtered));

app.on('/map-set-boundary', (boundary) => {
  // Assign to global variables
  southwest = boundary.southwest;
  northeast = boundary.northeast;

  if (!houzezMap) {
    init_map();
  }
  const bounds = [[southwest.lat, southwest.lng], [northeast.lat, northeast.lng]];
  houzezMap.fitBounds(bounds);

  // create an orange rectangle
  if (circle) {
    houzezMap.removeLayer(circle);
  }

  const d_lat = (southwest.lat + northeast.lat) / 2;
  const d_lng = (southwest.lng + northeast.lng) / 2;
  const radius = getDistance([southwest.lat, southwest.lng], [northeast.lat, northeast.lng]) / 2;
  circle = L.circle([d_lat, d_lng], { radius, color: '#ff7800', weight: 1 });
  circle.addTo(houzezMap);

  houzezMap.on('moveend', () => {
    const { x, y } = houzezMap.getSize();
    if (x && y) {
      const updatedBounds = houzezMap.getBounds();
      app.run('/map-load-list', updatedBounds.getSouthWest(), updatedBounds.getNorthEast());
    } else {
      app.run('/map-load-list', southwest, northeast);
    }
  });

});

app.on('/map-zoomout', (level) => {
  const currentzoom = level? level: houzezMap.getZoom();
  houzezMap.setZoom(currentzoom - 1);
});

app.on('/openMarker', function (title) {
  const selectedMarkers = markers.filter(m => m.options.title && title && m.options.title.trim().toUpperCase() === title.trim().toUpperCase());

  if (selectedMarkers) {
    let popupZoom = selectedMarkers[0].__parent._zoom + 1;

    const current = parseInt(houzezMap.getZoom(), 10);

    if (popupZoom <= 0) {
      popupZoom = 10;
    } else if (popupZoom < current) {
      popupZoom = current;
    }
    houzezMap.off('zoomend', reload_listings);
    houzezMap.setView(new L.LatLng(selectedMarkers[0]._latlng.lat, selectedMarkers[0]._latlng.lng), popupZoom);
    houzezMap.on('zoomend', reload_listings);
    setTimeout(function () {
      if (!selectedMarkers[0]._icon) {
        selectedMarkers[0].__parent.spiderfy();
      }
    }, 300);
    setTimeout(function () { selectedMarkers[0].fire('click'); }, 350);
  }
});

function reload_listings() {
  houzezMap.once('moveend', () => {
    const bounds = houzezMap.getBounds();
    const lowerBounds = bounds.getSouthWest();
    const upperBounds = bounds.getNorthEast();
    // Check if bounds are equal, if so use global southwest and northeast
    if (lowerBounds.lat === upperBounds.lat && lowerBounds.lng === upperBounds.lng && southwest && northeast) {
      app.run('/map-load-list', southwest, northeast);
    } else {
      app.run('/map-load-list', lowerBounds, upperBounds);
    }
  });
}

function init_map() {
  const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  });

  const fallbackMapOptions = {
    center: [43.723358, -79.335350],
    zoom: 10,
    closePopupOnClick: false
  };

  if (map_data) {
    const mapBounds = getMapBounds(map_data);
    if (1 === mapBounds.length) {
      fallbackMapOptions['center'] = L.latLng(mapBounds[0]);
    }
  }

  houzezMap = L.map('houzez-properties-map', fallbackMapOptions);
  houzezMap.addLayer(tileLayer);

  // houzezMap.on('zoomend', function () {
  //   const bounds = houzezMap.getBounds();
  //   const current = parseInt(houzezMap.getZoom(), 10);
  //   if (!prev_zoom_level) { prev_zoom_level = current; }
  //   if (current >= prev_zoom_level) {
  //     app.run('/map-refresh-list', bounds);
  //   } else {
  //     reload_listings();
  //   }
  // });

  houzezMap.on('zoomend', reload_listings);
  houzezMap.on('dragend', reload_listings);

  const div = document.createElement('div');
  div.style.cssText = `
    left: calc(50% - 10px);
    top: calc(50% - 10px);
    position: absolute;
    width: 20px;
    height: 20px;
    z-index: 10000;
    text-align: center;
    font-size: 20px;
    color: #f00;
    pointer-events: none; 
  `;
  div.innerHTML = '+';
  document.getElementById('houzez-properties-map').appendChild(div);

}

function getMapBounds(mapDataProperties) {
  // get map bounds
  const mapBounds = [];
  for (let i = 0; i < mapDataProperties.length; i++) {
    if (mapDataProperties[i].lat && mapDataProperties[i].lng) {
      mapBounds.push([mapDataProperties[i].lat, mapDataProperties[i].lng]);
    }
  }
  return mapBounds;
}

function houzezAddMarkers(map_properties, filtered) {
  function removeMarkers() {
    // Loop through markers and set map to null for each
    for (let i = 0; i < markers.length; i++) {
      houzezMap.removeLayer(markers[i]);
    }
    // Reset the markers array
    markers = [];
    if (osm_markers_cluster) {
      houzezMap.removeLayer(osm_markers_cluster);
    }
  }

  map_data = map_properties.sort((a, b) => a.lng - b.lng || a.lat - b.lat);

  if (!houzezMap) {
    init_map();
  } else {
    removeMarkers();
  }

  const mBounds = getMapBounds(map_properties);

  if (0 < mBounds.length && !filtered) {
    houzezMap.off('zoomend', reload_listings);
    houzezMap.fitBounds(mBounds);
    houzezMap.on('zoomend', reload_listings);
  }

  osm_markers_cluster = new L.MarkerClusterGroup({
    iconCreateFunction: function (cluster) {
      const markers1 = cluster.getAllChildMarkers();
      const html = '<div class="houzez-osm-cluster">' + markers1.length + '</div>';
      return L.divIcon({ html: html, className: 'mycluster', iconSize: L.point(47, 47) });
    },
    spiderfyOnMaxZoom: true, showCoverageOnHover: true, zoomToBoundsOnClick: true,
  });

  for (let i = 0; i < map_properties.length; i++) {

    if (map_properties[i].lat && map_properties[i].lng) {

      const mapData = map_properties[i];
      const mapCenter = L.latLng(mapData.lat, mapData.lng);

      const iconOptions = {
        iconUrl: mapData.marker,
        iconSize: [24, 36],
        iconAnchor: [24, 36],
        popupAnchor: [1, -36],
        iconRetinaUrl: mapData.retinaMarker
      };

      const icon = L.icon(iconOptions);

      const markerOptions = {
        riseOnHover: true,
        title: mapData.title,
        icon,
      };

      const propertyMarker = new L.Marker(mapCenter, markerOptions);

      osm_markers_cluster.addLayer(propertyMarker);

      const mainContent = document.createElement('div');
      mainContent.className = 'map-info-window';
      mainContent.style.width = '200px;';
      markers.push(propertyMarker);
      propertyMarker.bindPopup(mainContent);

      propertyMarker.on('popupclose', function () {
        app.run('/highlight-card', null);
      });

      propertyMarker.on('click', function (e) {
        mainContent.innerHTML = mapData.popup;
        const popup = e.target.getPopup();
        popup.setContent(mainContent);
        app.run('/highlight-card', mapData);
      });

    } // end if lat lng
  } // end for loop

  houzezMap.addLayer(osm_markers_cluster);
}

$('#listing-mapzoomin').on('click', function () {
  let current = parseInt(houzezMap.getZoom(), 10);
  //prev_zoom_level = current;
  current++;
  if (current > 20) {
    current = 20;
  }
  houzezMap.setZoom(current);
});

$('#listing-mapzoomout').on('click', function () {
  let current = parseInt(houzezMap.getZoom(), 10);
  current--;
  if (current < 0) {
    current = 0;
  }
  houzezMap.setZoom(current);
});

$('#houzez-gmap-full-osm').on('click', function () {
  // eslint-disable-next-line @typescript-eslint/no-invalid-this
  const $this = $(this);
  if ($this.hasClass('active')) {
    $this.removeClass('active');
    $this.parents('.map-wrap').removeClass('houzez-fullscreen-map');
  } else {
    $this.parents('.map-wrap').addClass('houzez-fullscreen-map');
    $this.addClass('active');
  }
  houzezMap.invalidateSize();
  houzezAddMarkers(map_data, true);
});

$('#houzez-btn-map-view').on('click', function (e) {
  e.preventDefault();
  $('#half-map-listing-area, .listing-wrap').hide();
  $('#map-view-wrap').show();

  app.run('/set_map_view', 1);

  houzezMap.invalidateSize();
  houzezAddMarkers(map_data, false);
});

$('#houzez-btn-listing-view').on('click', function (e) {
  e.preventDefault();
  $('#half-map-listing-area, .listing-wrap').show();
  $('#map-view-wrap').hide();

  app.run('/set_map_view', 2);
});

const houzez_map_next = function (hMap) {
  current_marker++;
  if (current_marker > markers.length) {
    current_marker = 1;
  }
  while (markers[current_marker - 1].visible === false) {
    current_marker++;
    if (current_marker > markers.length) {
      current_marker = 1;
    }
  }
  let popupZoom = hMap.getZoom();
  if (popupZoom > 15) {
    popupZoom = 15;
  }
  if (popupZoom < 8) {
    popupZoom = 10;
  }
  hMap.setView(new L.LatLng(markers[current_marker - 1]._latlng.lat, markers[current_marker - 1]._latlng.lng), popupZoom);
  setTimeout(function () {
    if (!markers[current_marker - 1]._icon) {
      markers[current_marker - 1].__parent.spiderfy();
    }
  }, 500);

  // if (hMap.getZoom() < 15) {
  //     hMap.setZoom(15);
  // }

  // hMap.setView(markers[current_marker - 1].getLatLng());
  // if (!markers[current_marker - 1]._icon) {
  //     markers[current_marker - 1].__parent.spiderfy();
  // }

  // hMap.setZoom(20);

  if ((current_marker - 1) === 0 || (current_marker - 1) === markers.length) {
    setTimeout(function () { markers[current_marker - 1].fire('click'); }, 500);
  } else {
    markers[current_marker].fire('click');
  }

};

const houzez_map_prev = function (hMap) {
  current_marker--;
  if (current_marker < 1) {
    current_marker = markers.length;
  }
  while (markers[current_marker - 1].visible === false) {
    current_marker--;
    if (current_marker > markers.length) {
      current_marker = 1;
    }
  }

  let popupZoom = hMap.getZoom();
  if (popupZoom > 15) {
    popupZoom = 15;
  }
  if (popupZoom < 8) {
    popupZoom = 10;
  }
  hMap.setView(new L.LatLng(markers[current_marker - 1]._latlng.lat, markers[current_marker - 1]._latlng.lng), popupZoom);
  setTimeout(function () {
    if (!markers[current_marker - 1]._icon) {
      markers[current_marker - 1].__parent.spiderfy();
    }
  }, 500);

  // if (hMap.getZoom() < 15) {
  //     hMap.setZoom(15);
  // }

  // hMap.setView(markers[current_marker - 1].getLatLng());
  // if (!markers[current_marker - 1]._icon) {
  //     markers[current_marker - 1].__parent.spiderfy();
  // }

  // hMap.setZoom(20);

  if ((current_marker - 1) === 0 || (current_marker) === markers.length) {
    setTimeout(function () { markers[current_marker - 1].fire('click'); }, 500);
  } else {
    markers[current_marker - 1].fire('click');
  }
};

$('#houzez-gmap-next').on('click', function () {
  houzez_map_next(houzezMap);
});

$('#houzez-gmap-prev').on('click', function () {
  houzez_map_prev(houzezMap);
});
